import { colors } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { rowHeight, stickyCell } from "Catalog/Grid/shared/components/GridTable/styles"

export interface BaseCellProps {
  isSelected: boolean
  isMouseOver: boolean
  width: number
  stickyPosition?: number
  isLastSticky?: boolean
}

export const BaseCell = styled.div<BaseCellProps>`
  width: ${({ width }) => width}px;
  height: ${rowHeight}px;
  ${({ stickyPosition, isLastSticky }) => stickyCell(stickyPosition, isLastSticky)};

  outline: 1px solid ${colors.borderLight};
  transition: background-color 0.1s;

  ${({ isSelected, isMouseOver }) => css`
    background-color: ${isSelected
      ? colors.backgroundLighter
      : isMouseOver
        ? colors.backgroundLightest
        : colors.backgroundWhite};
  `}
`
